import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { array, number } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import axios from 'axios';
import {
  startSetWebmasterNewsList,
  startSetWebmasterPromo,
  startSetNewsList,
  startSetPromo,
  startSetNewOffersNewsList,
  resetPromo,
  resetWebmasterPromo,
} from '../../../actions/news';
import NewsList from '../../../components/News/NewsList';
import NewsPromoList from '../../../components/News/NewsPromoList';
import Pagination from '../../../components/Pagination/Pagination';

import { NewsPageView } from '../index';

class NewsPage extends Component {
  static propTypes = {
    news: array.isRequired,
    newsTotal: number.isRequired,
    webmasterNews: array.isRequired,
    webmasterNewsTotal: number.isRequired,
    promotions: array.isRequired,
    webmasterPromotions: array.isRequired,
  };

  static defaultProps = {
    news: [],
    newsTotal: 0,
    promotions: [],
    webmasterNews: [],
    webmasterNewsTotal: 0,
    webmasterPromotions: [],
  };

  state = {
    newsLoading: false,
    // 1 - All, 2 - For me, 3 - New offers
    currentNewsTab: 1,
    promoLoading: false,
    // 2 - All, 1 - For me
    currentPromoTab: 2,
    // Page for all promos request params
    specialOffersPage: 1,
    // Page for my promos request params
    mySpecialOffersPage: 1,
    loadingMoreSpecialOffers: false,
    myNews: {
      limit: 25,
      page: 0,
    },
    myPromotions: {
      limit: 5,
      page: 0,
    },
    news: {
      limit: 25,
      page: 0,
    },
    promotions: {
      limit: 5,
      page: 0,
    },
    newOffersNews: {
      limit: 25,
      page: 0,
    },
    searchQuery: '',
  };

  componentDidMount() {
    this.setState(() => ({ newsLoading: true, promoLoading: true }));

    const { myNews, myPromotions, news, promotions, newOffersNews } = this.state;

    // news
    axios
      .all([
        this.props.startSetNewsList(news),
        this.props.startSetWebmasterNewsList(myNews),
        this.props.startSetNewOffersNewsList(newOffersNews),
      ])
      .then(() => {
        this.setState(() => ({ newsLoading: false }));
      });

    // promo
    axios
      .all([this.props.startSetPromo(promotions), this.props.startSetWebmasterPromo(myPromotions)])
      .then(() => {
        this.setState(() => ({ promoLoading: false }));
      });
  }

  componentWillUnmount() {
    this.props.resetPromo()
    this.props.resetWebmasterPromo()
  }

  handleNewsTabChange = tab => {
    this.setState({currentNewsTab: tab})
  }

  changeNewsPage = page => {
    this.setState(
      prevState => ({
        newsLoading: true,
        news: {
          ...prevState.news,
          page,
        },
      }),
      () => {
        const params = this.state.news;
        if (this.state.searchQuery) {
          params.type = 'search';
          params.query = this.state.searchQuery;
        }
        this.props
          .startSetNewsList(params)
          .then(() => this.setState(() => ({ newsLoading: false })));
      },
    );
  };

  changeMyNewsPage = page => {
    this.setState(
      prevState => ({
        newsLoading: true,
        myNews: {
          ...prevState.myNews,
          page,
        },
      }),
      () => {
        this.props
          .startSetWebmasterNewsList(this.state.myNews)
          .then(() => this.setState(() => ({ newsLoading: false })));
      },
    );
  };

  changeNewOffersNewsPage = page => {
    this.setState(
      prevState => ({
        newsLoading: true,
        newOffersNews: {
          ...prevState.newOffersNews,
          page,
        },
      }),
      () => {
        this.props
          .startSetNewOffersNewsList(this.state.newOffersNews)
          .then(() => this.setState(() => ({ newsLoading: false })));
      },
    );
  };

  loadMoreSpecialOffers = () => {
    this.setState(() => ({ loadingMoreSpecialOffers: true }), 
    () => {
      if(this.state.currentPromoTab === 2) {
        this.props.startSetPromo({ limit: 5, page: this.state.specialOffersPage })
        .then(() => this.setState((prev) => ({ specialOffersPage: prev.specialOffersPage + 1 })))
        .then(() => this.setState(({ loadingMoreSpecialOffers: false })))
      } else {
        this.props.startSetWebmasterPromo({ limit: 5, page: this.state.mySpecialOffersPage})
        .then(() => this.setState((prev) => ({ mySpecialOffersPage: prev.mySpecialOffersPage + 1 })))
        .then(() => this.setState(({ loadingMoreSpecialOffers: false })))
      }
    })
  }

  handlePromoTabChange = () => {
    this.setState((prev) => ({currentPromoTab: prev.currentPromoTab === 1 ? 2 : 1}))
  }

  handleSearch = (value) => {
    if (value !== this.state.searchQuery)
      this.setState(
        {
          newsLoading: true,
          searchQuery: value,
          currentNewsTab: 1,
          news: {
            ...this.state.news,
            page: 0,
          },
        },
        () => {
          if (this.state.searchQuery) {
            this.props
              .startSetNewsList({
                ...this.state.news,
                type: 'search',
                query: this.state.searchQuery,
                page: 0,
              })
              .then(() => this.setState({ newsLoading: false }));
          } else {
            this.props
              .startSetNewsList(this.state.news)
              .then(() => this.setState({ newsLoading: false }));
          }
        },
      );
  };

  navItemsNews = [
    <FormattedMessage id="news.tabs.all_news" defaultMessage="All" />,
    <FormattedMessage id="news.tabs.my_news" defaultMessage="For me" />,
    <FormattedMessage id="news.tabs.new_offers" defaultMessage="New offers" />,
  ];

  navItemsPromo = [
    <FormattedMessage id="news.tabs.all_news" defaultMessage="All" />,
    <FormattedMessage id="news.tabs.my_news" defaultMessage="For me" />,
  ];

  render() {
    const {
      webmasterNews,
      news,
      webmasterPromotions,
      promotions,
      newsTotal,
      webmasterNewsTotal,
      newOffersNews,
      newOffersNewsTotal,
    } = this.props;

    const { newsLoading, promoLoading, currentNewsTab } = this.state;

    const wmPageCount = Math.ceil(webmasterNewsTotal / this.state.myNews.limit) || 0;
    const pageCount = Math.ceil(newsTotal / this.state.news.limit) || 0;
    const newOffersPageCount = Math.ceil(newOffersNewsTotal / this.state.newOffersNews.limit) || 0;

    const newsPanes = [
      <Fragment>
        <NewsList news={news} groupByDate />
        {pageCount > 1 && (
          <Pagination
            pageCount={pageCount}
            onPageChange={this.changeNewsPage}
            activePage={this.state.news.page + 1}
            scrollToAfterPageChanged={{
              ref: this.cardHeaderRef,
            }}
          />
        )}
      </Fragment>,

      <Fragment>
        <NewsList news={webmasterNews} groupByDate />

        {wmPageCount > 1 && (
          <Pagination
            pageCount={wmPageCount}
            onPageChange={this.changeMyNewsPage}
            activePage={this.state.myNews.page + 1}
            scrollToAfterPageChanged={{
              ref: this.cardHeaderRef,
            }}
          />
        )}
      </Fragment>,

      <Fragment>
        <NewsList news={newOffersNews} groupByDate />

        {newOffersPageCount > 1 && (
          <Pagination
            pageCount={newOffersPageCount}
            onPageChange={this.changeNewOffersNewsPage}
            activePage={this.state.newOffersNews.page + 1}
            scrollToAfterPageChanged={{
              ref: this.cardHeaderRef,
            }}
          />
        )}
      </Fragment>,
    ];

    const promoPanes = [
      <NewsPromoList promotions={webmasterPromotions} />,
      <NewsPromoList promotions={promotions} />,
    ];
    
    return (
      <NewsPageView
        newsPanes={newsPanes}
        promoPanes={promoPanes}
        newsLoading={newsLoading}
        promoLoading={promoLoading}
        currentNewsTab={currentNewsTab}
        handleNewsTabChange={this.handleNewsTabChange}
        cardHeaderRef={this.cardHeaderRef}
        navItemsNews={this.navItemsNews}
        navItemsPromo={this.navItemsPromo}
        currentPromoTab={this.state.currentPromoTab} 
        loadingMoreSpecialOffers={this.state.loadingMoreSpecialOffers}
        loadMoreSpecialOffers={this.loadMoreSpecialOffers}
        handlePromoTabChange={this.handlePromoTabChange}
        handleSearch={this.handleSearch}
      />
    );
  }
}

const mapStateToProps = state => ({
  news: state.news.news,
  newsTotal: state.news.newsTotal,
  webmasterNews: state.news.myNews,
  webmasterNewsTotal: state.news.myNewsTotal,
  promotions: state.news.promotions,
  webmasterPromotions: state.news.myPromotions,
  newOffersNews: state.news.newOffersNews,
  newOffersNewsTotal: state.news.newOffersNewsTotal,
});

const mapDispatchToProps = dispatch => ({
  startSetWebmasterNewsList: params => dispatch(startSetWebmasterNewsList(params)),
  startSetWebmasterPromo: params => dispatch(startSetWebmasterPromo(params)),
  resetWebmasterPromo: () => dispatch(resetWebmasterPromo()),
  startSetNewsList: params => dispatch(startSetNewsList(params)),
  startSetPromo: params => dispatch(startSetPromo(params)),
  resetPromo: () => dispatch(resetPromo()),
  startSetNewOffersNewsList: params => dispatch(startSetNewOffersNewsList(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewsPage);
